import React, { useState } from "react";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Box, Button, Modal, Typography } from "@mui/material";
import GalleryImageUpload from "./GalleryImageUpload";
import ImageTable from "./ImageTable";
import { useGalleryStore } from "../../store/useGalleryStore";
import Loader from "../../Components/Loader";

const DisplayGallerySection = ({ formData, onEdit, onDelete }) => {
    const [open, setOpen] = useState(false);
    const [editId, setEditId] = useState(null);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [itemId, setItemId] = useState(null);
    const [loading, setLoading] = useState(false);

    const { deleteImageFormGallery } = useGalleryStore()

    const handleCancel = () => {
        setOpen(false);
        // window.location.reload()
    };

    const handleAddNewGallerySection = (id) => {
        setOpen(!open);
        setEditId(null);
    }

    const handleCancelDelete = () => {
        setDeleteOpen(false);
    };


    const handleConfirmDelete = async () => {
        try {
            setDeleteOpen(false)
            setLoading(true)
            const res = await deleteImageFormGallery(formData?._id, itemId)
            setDeleteOpen(false)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            setDeleteOpen(false)
            console.log(error)
        }
    }

    const onDeleteImage = async (id) => {
        setItemId(id)
        setDeleteOpen(true)
    }

    const onEditImage = async (id) => {
        setEditId(id)
        setOpen(true)
    }

    return (
        <div
            id="story-section"
            className=""
        >
            <div className="py-5 px-6">
                <div className="grid grid-cols-1 gap-6">
                    <div>
                        {/* === Section Title + Inline Buttons === */}
                        <div className="flex items-center justify-between mb-2">
                            <label className="block text-sm text-neutral-700">
                                Section Title
                            </label>

                            <div className="flex items-center space-x-2">
                                <button
                                    onClick={() => onEdit?.(formData)}
                                    className="flex items-center text-blue-600 hover:text-blue-800 text-sm"
                                >
                                    <EditOutlinedIcon sx={{ fontSize: 18, marginRight: "4px" }} />
                                    Edit
                                </button>

                                <button
                                    onClick={() => onDelete?.(formData)}
                                    className="flex items-center text-red-600 hover:text-red-800 text-sm"
                                >
                                    <DeleteOutlineIcon sx={{ fontSize: 18, marginRight: "4px" }} />
                                    Delete
                                </button>
                            </div>
                        </div>

                        <input
                            type="text"
                            name="title"
                            value={formData?.title || ""}
                            className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400 mb-4"
                            disabled
                        />


                        <div className="flex flex-wrap gap-4 mb-4">
                            <div className="flex-1 min-w-[150px]">
                                <label className="block text-sm text-neutral-700 mb-1">
                                    Order
                                </label>
                                <input
                                    type="text"
                                    value={formData?.order || ""}
                                    className="w-full p-3 border border-neutral-300 rounded-md text-sm bg-gray-50"
                                    disabled
                                />
                            </div>

                            <div className="flex-1 min-w-[150px]">
                                <label className="block text-sm text-neutral-700 mb-1">
                                    Status
                                </label>
                                <input
                                    type="text"
                                    value={formData?.isFeatured === true ? "Active" : "Inactive"}
                                    className={`w-full p-3 border rounded-md text-sm bg-gray-50 ${formData?.isFeatured === true
                                        ? "border-green-400 text-green-700"
                                        : "border-red-300 text-red-600"
                                        }`}
                                    disabled
                                />
                            </div>
                        </div>


                        <label className="block text-sm text-neutral-700 mb-2">
                            Description
                        </label>
                        <textarea
                            rows="2"
                            name="description"
                            value={formData?.description || ""}
                            className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400"
                            disabled
                        />
                    </div>
                </div>
            </div>

            <div className="px-6 py-0 mb-5 bg-white flex justify-between">
                <button
                    className="px-4 py-2 bg-neutral-900 text-white rounded-md"
                    onClick={() => {
                        handleAddNewGallerySection()
                    }}
                >
                    Add New Image
                </button>
            </div>

            <Loader loading={loading}>
                <ImageTable
                    images={formData?.image}
                    onEdit={(id) => onEditImage(id)}
                    onDelete={(id) => onDeleteImage(id)}
                />
            </Loader>

            <Modal
                open={open}
                onClose={handleCancel}
                aria-labelledby="confirm-delete-modal"
                aria-describedby="modal-to-confirm-deletion"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '5px',
                        boxShadow: 24,
                        width: { xs: "80%", md: "700px" },
                    }}
                >
                    <GalleryImageUpload
                        id={formData?._id}
                        imageId={editId}
                        setOpen={setOpen}
                        handleCancel={handleCancel}
                    />
                </Box>
            </Modal>

            <Modal
                open={deleteOpen}
                onClose={handleCancelDelete}
                aria-labelledby="confirm-delete-modal"
                aria-describedby="modal-to-confirm-deletion"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '5px',
                        boxShadow: 24,
                        width: { xs: "80%", md: "500px" },
                        textAlign: 'center',
                    }}
                >
                    <Typography variant="h6" gutterBottom>
                        Are you sure you want to delete this Image?
                    </Typography>
                    <Button variant="outlined" color="#274156" onClick={handleConfirmDelete}>
                        Yes
                    </Button>
                    <Button variant="outlined" color="#274156" onClick={handleCancelDelete} sx={{ marginLeft: '10px' }}>
                        No
                    </Button>
                </Box>
            </Modal>
        </div>
    );
};

export default DisplayGallerySection;
